import React from 'react';
import { useTheme } from '@mui/material/styles';

import { PersonLinkWithLabel } from 'common/components/person-link/person-link-with-label.component';
import { EllipsisText } from 'common/components/ellipsis-text/ellipsis-text.component';
import { Stack, Typography } from 'common/components/material';
import { useView } from 'common/hooks';

import { Praise, StyledPraiseBackground } from 'features/praise';
import { TagChips } from 'features/tags/components/tag-chips.component';

const PraiseCardContent: React.FC<{ praise: Praise }> = ({ praise }) => {
  const { description, headline, giver, tags } = praise;
  const { isMobileView } = useView();
  const { palette } = useTheme();

  return (
    <Stack>
      <StyledPraiseBackground py="1rem" px={isMobileView ? '1rem' : '2rem'}>
        <Stack pt={5} justifySelf="center" pb="1rem" spacing={1}>
          {headline && (
            <EllipsisText
              lineclamp={3}
              variant="h4"
              fontWeight={600}
              color={palette.Text.Headline}
            >
              {headline}
            </EllipsisText>
          )}
          {description && (
            <Typography
              variant="body3"
              color={palette.Text.Paragraph}
              pt={1}
              lineHeight="1.375rem"
            >
              {description}
            </Typography>
          )}
        </Stack>
        <Stack flexDirection="row" justifyContent="flex-end" alignItems="center">
          <PersonLinkWithLabel profile={giver} iconSize="medium" textVariant="body3" />
        </Stack>
      </StyledPraiseBackground>
      <TagChips tags={tags} />
    </Stack>
  );
};

export default PraiseCardContent;
